import "../../../styles/index.css"
import "./ModalEscolherPeça.css"
import OrdenarPor from "./../../Buttons/OrdenarPor/OrdenarPor"
import { useState, useEffect } from "react"
import { apiCategorias, apiSearch } from "../../../api/api"
import { ordemCrescente, ordemDecrescente } from "../../../utils/filtros"
import ImagemExemplo from "../../../assets/img/Imagem Exemplo.png"
import CardMontagem from "../../Cards/CardMontagem/CardMontagem"
import CustomButton from "../../Buttons/CustomButton/CustomButton"
import { categoryFromDatabase } from "../../../utils/categoryFromDatabase"
import Spinner from "../../Spinner/Spinner"

function ModalEscolherPeça({ idsProdutosEscolhidos, titulo, onClick }) {
	const [produtos, setProdutos] = useState([])
	const [produtosEmTela, setProdutosEmTela] = useState([])
	const [ordenarPor, setOrdenarPor] = useState("Menor")
	const [loaded, setLoaded] = useState(false)
	const itensPorPagina = 8

	useEffect(() => {
		setOrdenarPor("Menor")
	}, [titulo])

	useEffect(() => {

		if (titulo === null || titulo === undefined || titulo.trim() === "") {
			return
		}

		setLoaded(false)

		apiCategorias.listaProdutosCompativeis(categoryFromDatabase[titulo], idsProdutosEscolhidos).then((response) => {
			console.log(response)

			const produtosDisponiveis = adicionaProdutosDisponiveis(response)

			setProdutos(produtosDisponiveis)

			setProdutosEmTela(produtosDisponiveis.slice(0, itensPorPagina))
			setLoaded(true)
		})

	}, [titulo, idsProdutosEscolhidos])

	const adicionaProdutosDisponiveis = (response) => {
		console.log("Resposta da API: ", response)

		const produtosDisponiveis = []

		response.forEach((produto) => {
			if (produto.stores.length !== 0) {
				let disponivel = false

				produto.stores.forEach((store, index) => {
					if (store.stock_available === true) {
						disponivel = true
					} else {
						delete produto.stores[index]
					}
				})

				if (disponivel === true) {
					produtosDisponiveis.push(produto)
				}
			}
		})

		ordemCrescente(produtosDisponiveis)
		console.log("Produtos Disponiveis", produtosDisponiveis)
		return produtosDisponiveis
	}

	const ordenarPreço = () => {
		const produtosCopy = [...produtos]

		if (ordenarPor === "Menor") {
			setOrdenarPor("Maior")
			ordemDecrescente(produtosCopy)
		}

		if (ordenarPor === "Maior") {
			setOrdenarPor("Menor")
			ordemCrescente(produtosCopy)
		}

		setProdutos(produtosCopy)
		setProdutosEmTela(produtosCopy.slice(0, itensPorPagina))
	}

	const mostrarMaisProdutos = () => {
		setProdutosEmTela([...produtosEmTela, ...produtos.slice(produtosEmTela.length, produtosEmTela.length + itensPorPagina)])
	}

	const pesquisaProdutosCompativeis = (event) => {

		if (event.key === "Enter") {

			if (event.target.value === "") {

				apiCategorias.listaProdutosCompativeis(categoryFromDatabase[titulo], idsProdutosEscolhidos).then((response) => {
					const produtosDisponiveis = adicionaProdutosDisponiveis(response)
					setProdutos(produtosDisponiveis)
					setProdutosEmTela(produtosDisponiveis.slice(0, itensPorPagina))
					setLoaded(true)
				})

				return

			}

			console.log("Pesquisa de usuário na montagem: ", event.target.value)

			apiSearch.pesquisaProdutosCompativeis(event.target.value, categoryFromDatabase[titulo], idsProdutosEscolhidos).then((response) => {
				console.log(response)

				const produtosDisponiveis = adicionaProdutosDisponiveis(response)

				setProdutos(produtosDisponiveis)

				setProdutosEmTela(produtosDisponiveis.slice(0, itensPorPagina))
				setLoaded(true)
			})

			event.target.value = ""

		}

	}

	return (
		<div className="modal fade" id="modalEscolherPeça" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="modal-header">
						<h1 className="modal-title fs-5" id="exampleModalLabel">{`Escolha de ${titulo}`}</h1>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body corpoModalEscolherPeça">
						<div className="filtroModalPeça">
							<OrdenarPor ordem={ordenarPor} onClick={ordenarPreço} />
						</div>

						<div className='barra-pesquisa'>
							<input type="text" placeholder='Estou procurando por...' className='input-pesquisa-modal c1'
								onKeyDown={pesquisaProdutosCompativeis} />
						</div>

						<p className="b2 produtosEncontradosTextoMontagem">
							<span className="negrito">{produtos.length}</span> produtos encontrados
						</p>

						<div className="cards-listados-pesquisa">

							{

								!loaded ? <Spinner /> : produtosEmTela.map((produto) => {

									document.querySelector(".produtosEncontradosTextoMontagem").style.display = "block"

									const lojas = produto.stores

									const preços = []

									lojas.forEach((loja) => {
										if (loja.stock_available === true) {
											preços.push(parseFloat(loja.spot_price))
										}
									})

									const preço = Math.min(...preços)

									const preçoFormatado = preço.toString()

									const foto = produto["images"].length !== 0 ? produto["images"][0] : ImagemExemplo

									return (
										produto && (
											<CardMontagem
												key={produto["id"]}
												imagem={foto}
												nome={produto["name"]}
												preço={preçoFormatado}
												categoria={titulo}
												id={produto["id"]}
												tipoBotao={"Adicionar"}
												onClick={onClick}
											/>
										)
									)
								})

							}

						</div>

						<div className="btnVerMaisOfertas">
							{produtosEmTela.length < produtos.length && <CustomButton texto={"Ver mais"} cor={"white"} tipo='1' onClick={mostrarMaisProdutos} />}
						</div>

					</div>
				</div>
			</div>
		</div>
	)
}

export default ModalEscolherPeça
